/* Swaps the electrode rail to match the version the shopper picked.

   The entry kit ships four electrodes and the two larger kits ship six, so
   the heading, the strapline and each electrode's artwork all change with the
   choice, and the two body tubes only appear from the middle kit up.

   Markup contract - the heading and strapline carry data-lv-text-0/1/2, each
   image carries data-lv-img-0/1/2, and a card that is not in the entry kit
   carries data-lv-min-version.

   The version is normally the index of the checked variant radio, the same
   source of truth lv-ph.js writes to, so the rail follows the change whichever
   way the shopper made it: the custom cards or the theme's own picker.

   When the shop sells a single kit there is no choice to follow, and reading
   the radios would land on whichever variant happens to be first. The section
   can then carry data-lv-force-version to pin the rail to one kit; the server
   already renders that kit, so this only keeps it there. */
window.lvWiInit = function (id) {
  var sec = document.getElementById(id);
  if (!sec || sec.dataset.lvWi) return;
  sec.dataset.lvWi = '1';

  var forced = sec.getAttribute('data-lv-force-version');
  var isForced = forced !== null && forced !== '';

  function radios() {
    return [].slice.call(document.querySelectorAll(
      'variant-selects input[type="radio"], .product-form__input input[type="radio"]'));
  }

  function version() {
    if (isForced) return Number(forced);
    var rs = radios();
    for (var i = 0; i < rs.length; i++) if (rs[i].checked) return i;
    return 0;
  }

  function apply() {
    var v = version();

    sec.querySelectorAll('[data-lv-text-0]').forEach(function (el) {
      var t = el.getAttribute('data-lv-text-' + v);
      if (t !== null && el.innerHTML !== t) el.innerHTML = t;
    });

    sec.querySelectorAll('img[data-lv-img-0]').forEach(function (im) {
      var src = im.getAttribute('data-lv-img-' + v);
      if (src && im.getAttribute('src') !== src) im.setAttribute('src', src);
    });

    sec.querySelectorAll('[data-lv-min-version]').forEach(function (card) {
      card.hidden = Number(card.getAttribute('data-lv-min-version')) > v;
    });

    /* How many dots the rail can light depends on how many cards are on show,
       and its controller only recounts on scroll or resize. */
    window.dispatchEvent(new Event('resize'));
  }

  apply();
  if (isForced) return;

  document.addEventListener('change', function (e) {
    if (!e.target || e.target.type !== 'radio') return;
    if (e.target.closest('.product-form__input') || e.target.closest('variant-selects')) {
      setTimeout(apply, 0);
    }
  });

  /* Dawn renders the variant picker after this script runs, so the first read
     is retried until the radios exist - otherwise a page opened straight on a
     ?variant= link would render the entry kit's four cards. */
  var tries = 0;
  (function wait() {
    apply();
    if (!radios().length && tries++ < 40) setTimeout(wait, 150);
  })();
};
